document.addEventListener('DOMContentLoaded', function () {
  const form = document.querySelector('form[action="/cart/add"]');
  if (form) {
    form.addEventListener('submit', function () {
      const inputs = form.querySelectorAll('input[name^="properties["]');
      inputs.forEach(function (input) {
        const name = input.name;
        if (
          name.includes('article.no') ||
          name.includes('Incremental Length Unit') ||
          name.includes('_lengthUnit')
        ) {
          input.parentNode.removeChild(input);
        }
      });
    });
  }
});